import { RoeRoaValues, RoeRoaResult } from './types';

export function calculateRoeRoa(values: RoeRoaValues): RoeRoaResult {
  const { netIncome, totalAssets, shareholdersEquity } = values;

  const safeDiv = (num: number, den: number) => (den > 0 ? num / den : 0);

  return {
    roe: safeDiv(netIncome, shareholdersEquity),
    roa: safeDiv(netIncome, totalAssets),
  };
}


